<template src="./form.html"></template>

<script>
import { CreateVisit } from '@/api/visit'

export default {
  name: 'add-visit',
  data: function () {
    return {
      model: {
        studyid: this.$route.params.id,
        order: '',
        baseline: null,
        visit_at: null,
        lower: null,
        upper: null
      },
      ruleValidate: {
        visit: [{
          required: true,
          message: '访视不能为空',
          trigger: 'change'
        }]
      }
    }
  },
  methods: {
    handleSubmit: function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.postForm()
        } else {
          this.$Message.error('信息填写有误!')
        }
      })
    },
    postForm: function () {
      CreateVisit(this.model).then(async res => {
        if (res.id) {
          this.$Message.success('已添加到成员列表！')
          this.$emit('refresh')
        }
      })
    }
  }
}
</script>
